export const PASS_SIGNIN_METHODS = {
  qr: 'qr',
  invitation: 'invitation',
  gps: 'gps',
  default: 'default',
  auto: 'auto',
  webcheckin: 'webcheckin',
};

export const PASS_SIGNOUT_METHODS = {
  ...PASS_SIGNIN_METHODS,
};

export const PASS_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  REJECTED: 'rejected',
  EXPIRED: 'expired',
};

export const PSEUDO_PASS_STATUSES = {
  ARRIVING_SOON: 'arriving-soon',
  WATCHLIST_FLAGGED: 'watchlist-flagged',
  AUTO_EXPIRED: 'auto-expired',
};

export const PASSES_FETCH_LIMIT = 100;

export const PASSES_PAGE_SIZE = 25;

export const PASSES_REFRESH_RATE = 60000;

export const PASS_STATUSES = Object.values(PASS_STATUS);

export const PASS_ACTIONS = {
  ACCEPT: 'accept',
  REJECT: 'reject',
};
